import { teams } from "../data/teams";

export const createTeamMappingService = (teamsList, emailDomain) => {
  const mapping = {};

  teamsList.forEach((team) => {
    team.players.forEach((player) => {
      const email = `${player
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/[^a-z]/g, "")}@${emailDomain}`;
      mapping[email] = {
        teamId: team.id,
        teamName: team.name,
        playerName: player,
        teammate: team.players.find((p) => p !== player),
      };
    });
  });

  return {
    getTeamByEmail(email) {
      return mapping[email] || null;
    },

    canEditTeamScores(userEmail, teamId) {
      const userTeam = this.getTeamByEmail(userEmail);
      return userTeam && userTeam.teamId === parseInt(teamId);
    },

    getEditableTeams(userEmail) {
      const userTeam = this.getTeamByEmail(userEmail);
      return userTeam ? [userTeam] : [];
    },

    getUserTeamId(userEmail) {
      const userTeam = this.getTeamByEmail(userEmail);
      return userTeam ? userTeam.teamId : null;
    },

    getAllMappings() {
      return mapping;
    },

    getTeamById(teamId) {
      return teamsList.find((team) => team.id === parseInt(teamId));
    },

    getAllTeams() {
      return teamsList;
    },
  };
};

export const teamMappingService = createTeamMappingService(teams, "ar2026.golf");
